// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

/**
 * Komponenta pro vložení boxu s citací do stránky
 *
 */

const fragments = {
    TITLE: '[data-fragment="CitationBox.title"]',
    TEXT: '[data-fragment="CitationBox.text"]'
};
export default class CitationBox extends WebComponent {
    didMount() {
        const self = this;
        const lang = document.querySelector('html').getAttribute('lang');
        const titleElement = this.element.querySelector(fragments.TITLE);
        const textElement = this.element.querySelector(fragments.TEXT);
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4){

                if (titleElement.innerText == titleElement.dataset.original && textElement.innerText == textElement.dataset.original) {
                    self.element.innerHTML = xhr.responseText;
                } else {
                    let html = xhr.responseText;
                    if (titleElement.innerText != titleElement.dataset.original) {
                        html = html.replace(/<h4 class="blockquote__header">(((?!<\/h4>).|\n|\r)*)<\/h4>/gm,'<h4 class="blockquote__header">'+titleElement.innerText+'</h4>');
                    }
                    if (textElement.innerText != textElement.dataset.original) {
                        html = html.replace(/<div class="blockquote__content">(((?!<\/div>).|\n|\r)*)<\/div>/gm,'<div class="blockquote__content"><p>'+textElement.innerText+'</p></div>');
                    }
                    self.element.innerHTML = html;
                }
            }
        };
        xhr.open('GET', '/'+lang+'/system/includes/citace/index.shtml');
        xhr.send();
    };
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CitationBox.js